import type { IErrorResponse } from '@/types/apis/Error';
import type { LessonListItem } from '@/types/apis/Lesson';
import type { PaginationResponse } from '@/types/PaginationResponse';

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import url from '@/statics/urls';

const useNewestEducationContent = (): UseQueryResult<
  LessonListItem,
  IErrorResponse
> => {
  return useQuery({
    queryKey: [`${url.educationContents}?tag=newest&pageSize=1`],
    select: (result: PaginationResponse<LessonListItem>) => result.list[0],
  });
};
export default useNewestEducationContent;
